import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const unsubscribeMutation = graphql(
  gql`
    mutation unsubscribe($userId: String!) {
      unsubscribe(userId: $userId) {
        message
      }
    }
  `,
  {
    name: 'unsubscribeUser'
  }
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Unsubscribe/data.ts